import React from "react";

/** A rendering error in one section shows up as a message with the error text,
 *  instead of unmounting the whole page to a blank screen (no boundary anywhere
 *  before 16 Oct 2026 — a tab crash looked like the app not loading). */
export class ErrorBoundary extends React.Component<{ label?: string; children: React.ReactNode }, { error: Error | null }> {
  state = { error: null as Error | null };
  static getDerivedStateFromError(error: Error) { return { error }; }
  componentDidCatch(error: Error, info: React.ErrorInfo) { console.error(`[ui] ${this.props.label ?? "section"} crashed:`, error, info.componentStack); }
  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="rounded-xl border border-red-200 bg-red-50 p-4 text-sm text-red-800">
        <p className="font-semibold">{this.props.label ?? "This section"} couldn't be shown.</p>
        <p className="mt-1 font-mono text-xs">{String(this.state.error?.message ?? this.state.error)}</p>
        <button type="button" className="mt-2 rounded-md border border-red-300 bg-white px-2.5 py-1 text-xs font-medium hover:bg-red-100" onClick={() => { this.setState({ error: null }); window.location.reload(); }}>Reload</button>
      </div>
    );
  }
}
